import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { getTypographyStyles, SYS_SPACE_FIXED_200, SYS_SIZE_FIXED_1000, SYS_SIZE_FIXED_400, CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL } from '@oneaudi/unified-web-common';
import { getMargins } from '@oneaudi/unified-web-common';
import {} from './index.js';
export const StyledMarkdown = styled(Markdown) `
  margin: ${(props) => getMargins(props.$margin)};

  ul,
  ol {
    margin: 0;
    ${getTypographyStyles(CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL)};
    color: ${(props) => props.theme.sem.color.ui.foreground.text.default};
    padding: 0 0 0 calc(SYS_SIZE_FIXED_400 + SYS_SPACE_FIXED_200);
    list-style-type: none;
    counter-reset: section;
    position: relative;

    li {
      list-style: none;
      counter-increment: section;

      &::before {
        position: absolute;
        left: 0;
        text-align: end;
        width: ${SYS_SIZE_FIXED_400};
        margin-right: ${SYS_SPACE_FIXED_200};
      }

      &:not(:last-child) {
        margin-bottom: ${SYS_SPACE_FIXED_200};
      }
    }

    ol,
    ul {
      margin: ${SYS_SPACE_FIXED_200} 0;
      counter-reset: subsection;
      transform: translateX(
        calc((${SYS_SIZE_FIXED_400} + ${SYS_SPACE_FIXED_200}) * -1)
      );
      padding: 0 0 0 calc(${SYS_SIZE_FIXED_1000} + ${SYS_SPACE_FIXED_200});

      li {
        counter-increment: subsection;

        &::before {
          width: ${SYS_SIZE_FIXED_1000};
        }
      }
    }
  }

  ol {
    li {
      &::before {
        content: counter(section, decimal) '.';
      }

      ol {
        li {
          &::before {
            content: counter(section, decimal) '.' counter(subsection, decimal)
              '.';
          }
        }
      }
    }
  }

  ul {
    li {
      &::before {
        content: '>';
      }
    }
  }

  h1,
  h2,
  h3,
  h4 {
    hyphens: auto;
  }

  h1 {
    margin-bottom: var(--spacing-relative-xl);
  }

  h2,
  h3,
  h4,
  p,
  span,
  div,
  ul,
  ol {
    margin-bottom: var(--spacing-relative-lg);
  }
`;
//# sourceMappingURL=index.styles.js.map